import React, { createContext, useContext, useEffect, useReducer } from 'react';
import { setAppInsightsUser } from '../appinsights';


interface AppState {
    user: {
      id: string;
      given_name: string;
      family_name: string;
      email: string;
    } | null;
    token: string | null;
}

type AppAction =
  | { type: 'SET_USER'; payload: { id: string; given_name: string; family_name: string; email: string } }
  | { type: 'SET_TOKEN'; payload: string }
  | { type: 'LOGOUT' };

const initialState: AppState = {
    user: null,
    token: null,
};

const appReducer = (state: AppState, action: AppAction): AppState => {
  switch (action.type) {
    case 'SET_USER':
      return {
        ...state,
        user: {
          id: action.payload.id,
          given_name: action.payload.given_name,
          family_name: action.payload.family_name,
          email: action.payload.email,
        },
      };

    case 'SET_TOKEN':
      return {
        ...state,
        token: action.payload,
      };

    case 'LOGOUT':
      return {
        ...state,
        user: null,
        token: null,
      };

    default:
      return state;
  }
};

const AppContext = createContext<{
    state: AppState;
    dispatch: React.Dispatch<AppAction>;
}>({
    state: initialState,
    dispatch: () => undefined,
});

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, initialState);

    /**
     * Sincroniza el usuario autenticado con Application Insights.
     * - SET_USER  → setAuthenticatedUserContext + custom dimensions (id, email, nombre)
     * - LOGOUT    → clearAuthenticatedUserContext
     * El telemetry initializer en appinsights.js lee _currentUser
     * y lo agrega a TODOS los eventos enviados a Azure.
     */
    useEffect(() => {
        setAppInsightsUser(state.user);
    }, [state.user]);

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => {
    return useContext(AppContext);
};
